import React, { memo } from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

// Helper to safely get nested/bracket path values (e.g. containers[0].containerSize)
function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const norm = path.replace(/\[(\w+)\]/g, ".$1").replace(/\['([^']+)'\]/g, ".$1");
  return norm.split(".").filter(Boolean).reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}

function AutocompleteStatic({
  disabled = false,
  formik,
  options = [],
  label,
  fieldName,
  errorKey,
}) {
  const { t } = useTranslation();
  const value = getByPath(formik?.values, fieldName) ?? null;
  const touched = getByPath(formik?.touched, fieldName);
  const errorMsg = getByPath(formik?.errors, errorKey);
  const hasError = Boolean(touched && errorMsg);

  return (
    <Autocomplete
      disabled={disabled}
      id={`auto-complete-static-${fieldName}`}
      options={options}
      value={value}
      onChange={(_, newValue) => formik.setFieldValue(fieldName, newValue)}
      isOptionEqualToValue={(option, val) => option === val}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label={t(label)}
          error={hasError}
          helperText={hasError ? errorMsg : undefined}
        />
      )}
    />
  );
}

AutocompleteStatic.propTypes = {
  disabled: PropTypes.bool,
  formik: PropTypes.shape({
    values: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  label: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  errorKey: PropTypes.string.isRequired,
};

export default memo(AutocompleteStatic);
